import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";
import Navbar from "../components/Navbar";
import "../styles/NotFound.css";

const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.documentElement.style.overflowX = "hidden";
    document.body.style.overflowX = "hidden";
    return () => {
      document.documentElement.style.overflowX = "auto";
      document.body.style.overflowX = "auto";
    };
  }, []);

  return (
    <div className="nf-shield">
      <Navbar />
      <div className="nf-body">
        <div className="nf-content">
          <div className="nf-giant-wrapper">
            <h1 className="nf-giant">404</h1>
          </div>
          <div className="nf-divider"></div>
          <h2 className="nf-sub">PAGE NOT FOUND</h2>
          <p className="nf-text">
            The link you followed may be broken, or the page may have been
            removed.
          </p>

          <div className="nf-btns">
            <button onClick={() => navigate("/")} className="nf-btn-go">
              <Home size={18} /> TAKE ME HOME
            </button>
            <button onClick={() => navigate(-1)} className="nf-btn-back">
              <ArrowLeft size={16} /> Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
